export default {
      id: "common__password-usage",
      viewBox: "0 0 92.7 88.2",
      url: __webpack_public_path__ + "img/icons.svg#common__password",
      toString: function () {
        return this.url;
      }
    }